export class Helpers {
	/**
	 * Generates an unique identifier
	 * By default it will generate a 36 length id, every character is in base 36.
	 * This identifier is used to generate the sessionId which is stored in the Session Storage,
	 * this id is used to load the TMX script when the app initializes
	 *
	 * @param len - number of characters that the id will contain
	 * @returns un unique ID: string
	 */
	static generateUniqueId(len?: number): string {
		if (!len) {
			len = 32;
		}
		let str = '';
		for (let i = 1; i < len + 1; i = i + 8) {
			str += Math.random().toString(36).substr(2, 10);
		}
		return str.substr(0, len);
	}
}
